import { render, staticRenderFns } from "./phase.vue?vue&type=template&id=c60fd0b8&scoped=true"
import script from "./phase.vue?vue&type=script&lang=js"
export * from "./phase.vue?vue&type=script&lang=js"
import style0 from "./phase.vue?vue&type=style&index=0&id=c60fd0b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60fd0b8",
  null
  
)

export default component.exports